import React, { useContext } from 'react';
import './Part5.css';
import { NavLink } from 'react-router-dom';
import { HomeContext } from '../../Context/HomeContext'; // ✅ Import context

const Part5 = () => {
  const { homeData, loading } = useContext(HomeContext); // ✅ Use context
  const topics = homeData?.trendingTopics || [];
  const displayedTopics = topics.slice(0, 4);
  
  if (loading || topics.length === 0) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <div className="loader-text">Loading Section...</div>
      </div>
    );
  }

  return (
    <section className="section3">
      <div className="container">
        <h2 className="section3-title">Trending Topics</h2>
        <div className="section3-grid">
          {displayedTopics.map((topic, index) => (
            <NavLink to={`/category/${topic.slug}`} className="card" key={topic.id || index}>
              <div className="card-img-wrapper">
                <img
                  src={`https://api.funfillia.com/${topic.thumbnail}`}
                  alt={topic.name}
                  className="card-img"
                />
                <div className="overlay">
                  <div className="card-content">
                    <span className="card-meta1">
                      <h3 className="card-title">{topic.description || topic.name}</h3>
                   
                    </span>
                  </div>
                </div>
              </div>
            </NavLink>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Part5;
